<template>
    <div class="home">


        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">VoiceChat</h5>

            <br class="no-move"/>

        </div>

        <div class="main-title">

            <br class="no-move"/>

            <h1 class="headers-text text-dark"><strong>{{ name }}'s VoiceChat Mute List:</strong></h1>

            <br class="no-move"/>

            <div class="home" style="max-width: 420px; max-height: 400px; margin: 0 auto; overflow-y: auto">
                <p class="text-dark" v-for="uuid in uuids" :key="uuid">
                    <a target="_blank" style="color: black" :href='"https://de.namemc.com/search?q=" + uuid'>{{ uuid }}</a>
                </p>
            </div>

            <br class="no-move"/>

            <div class="container">

                <h1 class="headers-text text-dark"><strong>Teilen:</strong></h1>

                <b-button @click="copy">Link kopieren</b-button>
            </div>

            <br class="no-move"/>
            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{today.getFullYear()}}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/support">Support</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/creator">Creator</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            uuids: [],
            name: null,
            today: new Date()
        }
    },
    mounted() {
        this.name = new URLSearchParams(location.search).get('name')
        this.uuids = location.hash.split('#')[1].split(',')
    },
    methods: {
        copy() {
            navigator.clipboard.writeText(location.href)
        }
    }
}
</script>

<style scoped>

</style>